import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "components/UniversalModalOverride";
import {Objects} from "components"


export default class Customers extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.currentId = ""
		this.handleStartDispo = this.handleStartDispo.bind(this);

	}

	handleStartDispo = (id) => (e) => {
		this.state.currentId = id
		this.toggle('modalOnePage')();
	}
	
	handleShowDuplicates = async () => {
		this.setState({loading: true});
		this.request = 'GET_ALL_CUSTOMERS_DUPLICATES';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL_CUSTOMERS_DUPLICATES');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})
	}

	handleShowRegular = async () => {
		this.setState({loading: true})
		this.request = 'GET_ALL';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})
	}

	render() {
		const {data, pages, limit, loading, columnsAnchor} = this.state;

		const extraColumns = [
			{
				Header: 'Notes',
				accessor: 'notes',
				show: !!this.state['column_notes'],
				toggle: 'column_notes'
			},
		];

		const columns = [

			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 110,
			// 	Cell: props => {
			// 		return (
			// 			<span>
			// 				<Link to={"/dispositions/one_page/0/" + props.original.binary_id + '-' + props.original.pkey}>
			// 					<Button color="blue-hoki" size={"sm"} block={true}>
			// 						Start 4473 <i className={"fa fa-arrow-right"}/></Button>
			// 				</Link>
			// 			</span>
			// 		);
			// 	}
			// },
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 110,
				Cell: props => {
					return (
						<Button

							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={this.handleStartDispo(props.original._id)}
							data-cy={`start-4473-${props.original.name_first+props.original.name_middle+props.original.name_last}`}
							>
							<i className={"fa fa-arrow-right"}/> Start 4473
						</Button>
					);
				}
			},

			{
				Header: "Name",
				accessor: "name_first|name_middle|name_last|name_suffix",
				Cell: props => <Link
					to={"/customers/" + props.original.binary_id + '-' + props.original.pkey}>  {props.original.name_first} {props.original.name_middle} {props.original.name_last} {props.original.name_suffix}</Link>
			},
			{
				Header: "Phone Number",
				id: "customer_numbers.number",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_numberss && obj.customer_numberss.length > 0 && obj.customer_numberss[0].number) ? obj.customer_numberss[0].number : '-'
			},
			{
				Header: "Email",
				id: "customer_emails.email",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_emailss && obj.customer_emailss.length > 0 && obj.customer_emailss[0].email) ? obj.customer_emailss[0].email : '-'
			},
			{
				Header: "Address",
				id: "customer_addresses.street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_addressess && obj.customer_addressess.length > 0 && obj.customer_addressess[0].street_1) ? obj.customer_addressess[0].street_1 + ' ' + obj.customer_addressess[0].city + ', ' + obj.customer_addressess[0].state + ' ' + obj.customer_addressess[0].zip : '-'
			},
			{
				Header: "DOB",
				id: "birth_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			...extraColumns,
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},


		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers', "")}
							{this.request === 'GET_ALL_CUSTOMERS_DUPLICATES' ? <Button color="primary" onClick={this.handleShowRegular} style={{marginLeft: '25px'}}>Show Regular</Button> :
								<Button color="warning" onClick={this.handleShowDuplicates} style={{marginLeft: '25px'}}>Show Duplicates</Button> }
							{this.renderHeaderRight("Customers", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}

						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}

						defaultPageSize={limit}
						pageSize={limit}
						className="-striped -highlight"

						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}

						pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
						renderPageSizeOptions={this.renderPageSizes}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<UniversalModalOverride
						title={"Start 4473"}
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						object={Objects.OnePage}
						objectProps={{
							customer: this.state.currentId
						}}
						name={"Start"}
						toggle={this.state['modalOnePage']}
						reportClose={this.reportClose('modalOnePage')}
						afterSave={this.handleAfterSave}
						size={'xl'}
					/>
				</CardContent>
			</Card>
		)
	}
}
